module.exports = __webpack_public_path__ + "img/belgium-transport-accidents-male.43e53c30.png";